import { Component } from '@angular/core';
import { FileManagerContentComponent } from './file-manager-content.component';

@Component({
    standalone: false,
    selector: 'lib-client-file-manager-content',
  templateUrl: './file-manager-content.component.html',
  styleUrls: ['./file-manager-content.component.scss']
})
export class ClientFileManagerContentComponent extends FileManagerContentComponent {
  constructor() {
    super('ClientDirectoryEntry');
  }
}
